export const LINKS = {
  LOGIN: '/login',
  RENTERS_INSURANCE: '/rent/renters-insurance/',
  RENTAL_MANAGER_LEASE_AGREEMENTS: 'https://www.zillow.com/z/rental-manager/rental-lease-agreements/',
  RENTAL_CREDIT_CLIMB_ENROLL: '/rental/creditclimb/enroll',
} as const;
